import React from 'react';
import './Typerotary.css';
import Aserie from '../../../imgs/Aseries1.webp';
import Aseri from '../../../imgs/Aseries2.webp';
import Aser from '../../../imgs/Aseries3.webp';

const Typerotary = () => {
    return (
        <div className="container">
<div className="Typerota-container">

            <div className="Typerota-content">

                <p className="Typerota-text">Among them, A-type, G-type, and T-type are
                    suitable for the production of Powerjet IBM rotary injection molding machines due to
                    factors such as inflation ratio, materials, machine size, and so on.</p>
            </div>
            <div className="Typerota">
                <img src={Aserie} alt="72 Generallyin PET Preforms Machine" className="Typerotar-image" />
                <img src={Aseri} alt="72 Generallyin PET Preforms Machine" className="Typerotar-image" />
                <img src={Aser} alt="72 Generallyin PET Preforms Machine" className="Typerotar-image" />

            </div>
        </div>
        </div>
        
    );
};

export default Typerotary;
